// extracted by mini-css-extract-plugin
export default {"counter":"counter__counter__v6J30","minus":"counter__minus__STiVa","num":"counter__num__GYeer","plus":"counter__plus__UHgA3","inactive":"counter__inactive__U3YXx"};